
<div class="content-render-legal-document-view" *ngIf="path" [path]="path" [instanceId]="instanceId"></div>